var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongShouqiXian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.5h13M6.5 6h8M6.5 10h8M1.5 14h13",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.184 8.154a.2.2 0 010-.308l2.488-2.073A.2.2 0 014 5.927v4.146a.2.2 0 01-.328.154L1.184 8.154z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_shouqi_xian.4473d25a.svg";
export { SvgTongyongShouqiXian as ReactComponent };